var _path, _path2, _path3;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLogOutSelect(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 4.5C4.73478 4.5 4.48043 4.60536 4.29289 4.79289C4.10536 4.98043 4 5.23478 4 5.5V19.5C4 19.7652 4.10536 20.0196 4.29289 20.2071C4.48043 20.3946 4.73478 20.5 5 20.5H9C9.55228 20.5 10 20.9477 10 21.5C10 22.0523 9.55228 22.5 9 22.5H5C4.20435 22.5 3.44129 22.1839 2.87868 21.6213C2.31607 21.0587 2 20.2957 2 19.5V5.5C2 4.70435 2.31607 3.94129 2.87868 3.37868C3.44129 2.81607 4.20435 2.5 5 2.5H9C9.55228 2.5 10 2.94772 10 3.5C10 4.05228 9.55228 4.5 9 4.5H5Z",
    fill: "#9F9978"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.2929 6.79289C15.6834 6.40237 16.3166 6.40237 16.7071 6.79289L21.7071 11.7929C22.0976 12.1834 22.0976 12.8166 21.7071 13.2071L16.7071 18.2071C16.3166 18.5976 15.6834 18.5976 15.2929 18.2071C14.9024 17.8166 14.9024 17.1834 15.2929 16.7929L19.5858 12.5L15.2929 8.20711C14.9024 7.81658 14.9024 7.18342 15.2929 6.79289Z",
    fill: "#9F9978"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 12.5C8 11.9477 8.44772 11.5 9 11.5H21C21.5523 11.5 22 11.9477 22 12.5C22 13.0523 21.5523 13.5 21 13.5H9C8.44772 13.5 8 13.0523 8 12.5Z",
    fill: "#9F9978"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogOutSelect);
export default __webpack_public_path__ + "static/media/log_out_select.b48ffb28f02cccddb6fb099bfa9cc271.svg";
export { ForwardRef as ReactComponent };